import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const OrderDetailBespokeListState = Immutable.fromJS({
	orderId: '',
	orderDetailList: []
});

const orderDetailBespokeListReducer = handleActions({

	FIND_ORDER_DETAIL_BESPOKE_LIST: (state, { payload }) => {
		return state.merge({
			orderDetailList: payload.data
		})
	}
}, OrderDetailBespokeListState);

export default orderDetailBespokeListReducer;


// WEBPACK FOOTER //
// ./src/reducers/orderDetailBespokeListReducer.js